import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import App from './src/js/App';
import './index.scss';

let path = location.hash.slice(1);
if (path) {
  location.hash = '';
  history.replaceState({}, '', `${ROOT_URL}${path}`);
}

let districts = fetch(`${ROOT_URL}assets/data/council-districts.json`).then(r => r.json());
let data = fetch(`${ROOT_URL}assets/data/races.json`).then(r => r.json());

Promise.all([districts, data])
  .then(([d, data]) => {
    ReactDOM.render(
      <App districts={d} races={data.races} questions={data.questions} />,
      document.getElementById('root')
    );
  });



// WEBPACK FOOTER //
// ./app/index.js